import { cn } from "@repo/shared/utils";
import { Label } from "./Label";
import { Select, SelectContent, SelectTrigger, SelectValue } from "./Select";
import { InputInfo } from "./InputInfo";

export type SelectInputProps = {
  value: string | undefined;
  onValueChange: (value: string) => void;
  label?: React.ReactNode;
  options: React.JSX.Element[];
  labelStyle?: string;
  containerStyle?: string;
  triggerStyle?: string;
  orientation?: "horizontal" | "vertical";
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
};

export const SelectInput = ({
  value,
  onValueChange,
  label,
  options,
  labelStyle,
  containerStyle,
  triggerStyle,
  orientation,
  placeholder,
  disabled,
  error,
  errorMessage,
}: SelectInputProps) => {
  return (
    <div
      className={cn(
        "flex gap-y-1 mt-1.5",
        orientation === "horizontal"
          ? "flex-row items-center gap-x-3"
          : "flex-col",
        containerStyle
      )}
    >
      {label && <Label className={labelStyle} label={label} />}

      <div className="flex flex-col gap-1 w-full">
        <Select onValueChange={onValueChange} value={value} disabled={disabled}>
          <SelectTrigger
            className={cn(
              triggerStyle,
              "[&>span]:inline-block [&>span]:truncate [&>span>br~*]:hidden"
            )}
          >
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>{options}</SelectContent>
        </Select>
        {error && errorMessage && <InputInfo info={errorMessage} />}
      </div>
    </div>
  );
};
